<script lang="ts">
  import DateComp from "$components/date-on-card/index.svelte";
  import Arrow from "$components/arrow/index.svelte";
  import LinkComp from "$components/link.svelte";
  import ImageComp from "$components/image.svelte";
  import Indicator from "$components/promo/indicator.svelte";
  import type { ICardsingle } from "./index";
  import type { Address } from "types/backend/models/address.entity";

  export let event: ICardsingle;
  export let locale: string;
  export let className = "";

  $: ({ datetime, title, venue, performers, product, tbc } = event);
  function toAddress(v?: { title: string; address: Partial<Address> }) {
    if (!v) {
      return "";
    }
    const { title = "", address } = v;
    return [title, address?.line1 || "", address?.city || ""].filter(v => v).join(", ");
  }
</script>

<LinkComp href={`${event?.subcategory?.slug}${event?.slug}`} {className}>
  <section class="card-wrapper grid">
    <DateComp date={datetime} {tbc} />
    <div class="content grid">
      <div class="img-promo">
        <div class="logos">
          {#if performers.length}
            {#each performers as performer}
              <ImageComp image={performer.attributes?.logo} className="club-logo" customWidth="24px" />
            {/each}
          {/if}
        </div>
        {#if product?.icon}
          <Indicator title={product?.icon || "2 tickets"} className={`${product?.icon || ""}`} hide="mob" />
        {/if}
      </div>
      <div class="details">
        <h3 class="pf-500">{title}</h3>
        <p class="pf-300 t2 address cut-text" title={toAddress(venue)}>{toAddress(venue)}</p>
        <p class="pf-500 t2">{event?.subcategory?.title || ""}</p>
      </div>
    </div>

    <div class="arrow-wrapper grid">
      <div>
        <Arrow />
      </div>
    </div>
  </section>
</LinkComp>

<style lang="scss">
  @use "@styles/breakpoint-mixins" as *;
  .card-wrapper {
    color: #000;
    padding: 0.5em;
    grid-template-columns: 3.125em auto 2em;
    gap: 0.5em;
    border-radius: 0.4375em;
    border: 1px solid #d8d8d8;

    @include desktop {
      grid-template-columns: 4.375em auto 2em;
      gap: 0.9375em;
      padding: 0.625em;
      border-radius: 0.4375em;
      border: 1px solid #d8d8d8;
    }
  }

  .img-promo {
    display: flex;
    gap: 0.5em;
    line-height: 1em;
  }

  .logos {
    display: flex;
    gap: 0.5em;
    height: 1.5626em;
  }

  .content {
    grid-template-columns: 1fr;
    color: #000;
    padding: 0;
    gap: 0.3em 0;
    place-content: center start;
    @include desktop {
      gap: 0.5em 0;
    }
  }

  .details {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 5px;

    h3,
    p {
      margin: 0;
      min-height: 20px;
    }
    h3 {
      font-size: 1em;
      line-height: 1.25rem;
    }
    .t2 {
      font-size: 0.875em; /*14px */
      line-height: 0.92857em; /* 13px */
    }
    .address {
      min-height: 15px;
    }
  }

  .arrow-wrapper {
    div {
      align-self: center;
      justify-self: end;
    }
  }
  .cut-text {
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
